<template>
  <div class="shadow-lg rounded-lg">
    <div
      class="bg-[#FAFBFC] py-3 px-6 flex justify-between items-center cursor-pointer"
      @click="toggleDropdown"
    >
      <div class="flex items-center gap-5">
        <img
          :src="
            isDropdownVisible
              ? require('@/assets/projects/Vector.svg')
              : require('@/assets/projects/Vector-1.svg')
          "
          alt="Toggle"
          class="w-3 h-3"
        />
        <span class="flex items-center text-[14px] gap-2">
          <div
            class="w-2 h-2 rounded-full"
            :class="statusConfig.dotColor"
          ></div>
          <span style="color: #4c4d4f">{{ statusConfig.label }}</span> -
          <span style="color: #667085">{{ tasks.length }}</span>
        </span>
        <!-- <img
          src="@/assets/tasks/ellipse.svg"
          alt="Ellipse Icon"
          class="w-4 h-4"
        /> -->
        <button
          class="flex items-center gap-2 text-[13px] cursor-pointer"
          style="color: #667085"
          :disabled="taskLimit && taskLimit.is_limit_reached"
          @click.stop="$emit('open-task-modal')"
        >
          <img src="@/assets/tasks/add-2.svg" alt="Add Icon" class="w-4 h-4" />
          Add Task
        </button>
      </div>
    </div>

    <!-- Task List -->
    <div v-if="isDropdownVisible" class="overflow-x-auto">
      <div v-if="tasks.length === 0" class="text-center py-16 text-gray-500">
        <p
          class="mx-auto bg-primaryLight px-2 py-24 border border-grayLight rounded-[16px]"
        >
          {{ statusConfig.emptyMessage }}
          <span
            @click="$emit('open-task-modal')"
            class="text-blue-500 cursor-pointer"
          >
            Create a new task </span
          >.
        </p>
      </div>

      <div v-else>
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-[#FAFBFC]">
            <tr class="text-[12px] font-normal text-bodyText">
              <td
                scope="col"
                class="pl-16 pr-6 py-3 text-left tracking-wider cursor-pointer hover:bg-gray-100"
                style="color: #4c4d4f"
                @click="sortBy('name')"
              >
                <div class="flex items-center gap-2">
                  Name
                  <span v-if="sortField === 'name'">
                    <span v-if="sortOrder === 'asc'">↑</span>
                    <span v-if="sortOrder === 'desc'">↓</span>
                  </span>
                </div>
              </td>
              <td
                scope="col"
                class="px-6 py-3 text-left tracking-wider cursor-pointer hover:bg-gray-100"
                style="color: #4c4d4f"
                @click="sortBy('assignee')"
              >
                <div class="flex items-center gap-2">
                  Talent
                  <span v-if="sortField === 'assignee'">
                    <span v-if="sortOrder === 'asc'">↑</span>
                    <span v-if="sortOrder === 'desc'">↓</span>
                  </span>
                </div>
              </td>
              <td
                scope="col"
                class="px-6 py-3 text-left tracking-wider"
                style="color: #4c4d4f"
              >
                <div class="flex items-center gap-2">
                  Created By
                </div>
              </td>
              <td
                scope="col"
                class="px-6 py-3 text-left tracking-wider cursor-pointer hover:bg-gray-100"
                style="color: #4c4d4f"
                @click="sortBy('start_date')"
              >
                <div class="flex items-center gap-2">
                  Start Date
                  <span v-if="sortField === 'start_date'">
                    <span v-if="sortOrder === 'asc'">↑</span>
                    <span v-if="sortOrder === 'desc'">↓</span>
                  </span>
                </div>
              </td>
              <td
                scope="col"
                class="px-6 py-3 text-left tracking-wider cursor-pointer hover:bg-gray-100"
                style="color: #4c4d4f"
                @click="sortBy('due_date')"
              >
                <div class="flex items-center gap-2">
                  Due Date
                  <span v-if="sortField === 'due_date'">
                    <span v-if="sortOrder === 'asc'">↑</span>
                    <span v-if="sortOrder === 'desc'">↓</span>
                  </span>
                </div>
              </td>
              <td
                scope="col"
                class="px-6 py-3 text-left tracking-wider cursor-pointer hover:bg-gray-100"
                style="color: #4c4d4f"
                @click="sortBy('priority')"
              >
                <div class="flex items-center gap-2">
                  Priority
                  <span v-if="sortField === 'priority'">
                    <span v-if="sortOrder === 'asc'">↑</span>
                    <span v-if="sortOrder === 'desc'">↓</span>
                  </span>
                </div>
              </td>
              <td
                scope="col"
                class="px-6 py-3 text-left tracking-wider"
                style="color: #4c4d4f"
              ></td>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <template v-for="task in sortedTasks" :key="task.task_id">
              <!-- Main Task Row -->
              <tr
                class="mb-2 bg-[#FAFBFC] text-[13px] text-grayDark hover:bg-primaryLight"
              >
                <td
                  class="pl-16 pr-6 py-4 whitespace-nowrap text-bodyText truncate max-w-[400px] flex gap-2 items-center"
                >
                  <img
                    v-if="task.sub_tasks && task.sub_tasks.length > 0"
                    :src="
                      subtaskVisibility[task.task_id]
                        ? require('@/assets/projects/Vector.svg')
                        : require('@/assets/projects/Vector-1.svg')
                    "
                    alt="Toggle Subtasks"
                    class="w-3 h-3 cursor-pointer"
                    @click="toggleSubtasks(task.task_id)"
                  />
                  <p
                    @click="$emit('open-side-menu', task)"
                    class="cursor-pointer relative group overflow-hidden"
                    :title="task.title.length > 50 ? task.title : ''"
                  >
                    {{ task.title }}
                    <span
                      v-if="task.title.length > 50"
                      class="absolute top-full left-0 mt-1 px-2 py-1 text-xs text-white bg-black rounded opacity-0 group-hover:opacity-100 whitespace-nowrap z-50 pointer-events-none"
                      style="min-width: max-content;"
                    >
                      {{ task.title }}
                    </span>
                  </p>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="flex items-center gap-2">
                    <div v-if="task.talent">
                      <div class="w-6 h-6 flex-shrink-0 relative group">
                        <img
                          :src="
                            task.talent.profile_picture ||
                            require('@/assets/users/default-profile-picture.jpg')
                          "
                          alt="Profile Picture"
                          class="w-full h-full rounded-full object-cover"
                        />
                        <span
                          class="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 px-2 py-1 text-xs text-white bg-black rounded opacity-0 group-hover:opacity-100"
                        >
                          {{ task.talent.first_name }}
                          {{ task.talent.last_name }}
                        </span>
                      </div>
                    </div>
                    <div v-else-if="task.team">
                      <div class="flex -space-x-2">
                        <template
                          v-for="(member) in task.team.members.slice(0, 3)"
                          :key="member.id"
                        >
                          <div class="w-6 h-6 flex-shrink-0 relative group">
                            <img
                              :src="
                                member.profile_picture ||
                                require('@/assets/users/default-profile-picture.jpg')
                              "
                              alt="Profile Picture"
                              class="w-full h-full rounded-full object-cover"
                            />
                            <span
                              class="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 px-2 py-1 text-xs text-white bg-black rounded opacity-0 group-hover:opacity-100"
                            >
                              {{ member.first_name }} {{ member.last_name }}
                            </span>
                          </div>
                        </template>
                        <div
                          v-if="task.team.members.length > 3"
                          class="w-6 h-6 flex-shrink-0 flex items-center justify-center bg-gray-300 text-xs text-white rounded-full"
                        >
                          +{{ task.team.members.length - 3 }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="flex items-center gap-2">
                    <div v-if="task.created_by">
                      <div class="w-6 h-6 flex-shrink-0 relative group">
                        <img
                          :src="
                            task.created_by.profile_picture ||
                            require('@/assets/users/default-profile-picture.jpg')
                          "
                          alt="Created By Picture"
                          class="w-full h-full rounded-full object-cover"
                        />
                        <span
                          class="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 px-2 py-1 text-xs text-white bg-black rounded opacity-0 group-hover:opacity-100"
                        >
                          {{ task.created_by.first_name }}
                          {{ task.created_by.last_name }}
                        </span>
                      </div>
                    </div>
                    <div v-else>
                      <div class="w-6 h-6 flex-shrink-0 relative group">
                        <img
                          :src="require('@/assets/users/default-profile-picture.jpg')"
                          alt="No Creator"
                          class="w-full h-full rounded-full object-cover"
                        />
                        <span
                          class="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 px-2 py-1 text-xs text-white bg-black rounded opacity-0 group-hover:opacity-100"
                        >
                          N/A
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  {{ formatDate(task.start_date) }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  {{ formatDate(task.due_date) }}
                </td>
                <td class="flex items-center gap-2 px-6 py-4 whitespace-nowrap">
                  <img
                    :src="getPriorityFlag(task.priority)"
                    alt="Priority Flag"
                    class="h-3"
                  />
                  {{ task.priority }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-center">
                  <button
                    @click="toggleMenu(task.task_id, $event)"
                    class="cursor-pointer relative"
                  >
                    <img
                      src="@/assets/tasks/ellipse.svg"
                      alt="Actions"
                      class="w-4 h-4"
                    />
                  </button>
                  <div
                    v-if="menuVisibility[task.task_id]?.visible"
                    :style="{
                      position: 'fixed',
                      top: `${menuVisibility[task.task_id]?.top}px`,
                      left: `${menuVisibility[task.task_id]?.left}px`,
                      zIndex: 50
                    }"
                    class="w-40 bg-white shadow-lg rounded-lg"
                  >
                    <!-- Invisible overlay -->
                    <div
                      class="fixed inset-0 bg-transparent"
                      @click="closeAllMenus"
                    ></div>
                    <!-- Menu content -->
                    <ul class="text-sm text-gray-700 relative z-10">
                      <li
                        @click="handleAction('view', task)"
                        class="px-4 py-2 hover:bg-gray-100 flex items-center gap-2 cursor-pointer"
                      >
                        <img
                          src="@/assets/auth/view.svg"
                          alt="View"
                          class="w-4 h-4"
                        />
                        View
                      </li>
                      
                        <li
                          @click="handleAction('edit', task)"
                          class="px-4 py-2 hover:bg-gray-100 flex items-center gap-2 cursor-pointer"
                        >
                          <img
                            src="@/assets/tasks/rename.svg"
                            alt="Rename"
                            class="w-4 h-4"
                          />
                          Edit
                        </li>
                      <li
                        @click="handleAction('rename', task)"
                        class="px-4 py-2 hover:bg-gray-100 flex items-center gap-2 cursor-pointer"
                      >
                        <img
                          src="@/assets/tasks/rename.svg"
                          alt="Rename"
                          class="w-4 h-4"
                        />
                        Rename
                      </li>
                      <li
                        @click="handleAction('add-sub-task', task)"
                        class="px-4 py-2 hover:bg-gray-100 flex items-center gap-2 cursor-pointer"
                      >
                        <img
                          src="@/assets/tasks/add.svg"
                          alt="Duplicate"
                          class="w-4 h-4"
                        />
                        Add Sub Task
                      </li>
                      <li
                        @click="handleAction('duplicate', task)"
                        class="px-4 py-2 hover:bg-gray-100 flex items-center gap-2 cursor-pointer"
                      >
                        <img
                          src="@/assets/tasks/copy.svg"
                          alt="Duplicate"
                          class="w-4 h-4"
                        />
                        Duplicate
                      </li>
                      <li
                        @click="handleAction('delete', task)"
                        class="px-4 py-2 hover:bg-gray-100 flex items-center gap-2 cursor-pointer"
                      >
                        <img
                          src="@/assets/tasks/trash.svg"
                          alt="Delete"
                          class="w-4 h-4"
                        />
                        Delete
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>

              <!-- Subtask Rows -->
              <template
                v-if="
                  subtaskVisibility[task.task_id] &&
                  task.sub_tasks &&
                  task.sub_tasks.length > 0
                "
              >
                <tr
                  v-for="subtask in task.sub_tasks"
                  :key="subtask.task_id"
                  class="bg-gray-50 text-[12px] text-grayDark hover:bg-gray-100 border-gray-300"
                >
                  <td
                    class="px-28 py-4 whitespace-nowrap text-bodyText truncate max-w-[400px]"
                  >
                    <div class="flex items-center gap-2">
                      <input
                        type="radio"
                        :name="`subtask-${task.task_id}`"
                        :value="subtask.task_id"
                        class="w-3 h-3 text-blue-600 cursor-pointer"
                      />
                      <p
                        @click="$emit('open-side-menu', subtask)"
                        class="cursor-pointer relative group overflow-hidden"
                        :title="subtask.title.length > 50 ? subtask.title : ''"
                      >
                        {{ subtask.title }}
                        <span
                          v-if="subtask.title.length > 50"
                          class="absolute top-full left-0 mt-1 px-2 py-1 text-xs text-white bg-black rounded opacity-0 group-hover:opacity-100 whitespace-nowrap z-50 pointer-events-none"
                          style="min-width: max-content;"
                        >
                          {{ subtask.title }}
                        </span>
                      </p>
                    </div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <div class="flex items-center gap-2">
                      <div v-if="subtask.talent">
                        <div class="w-6 h-6 flex-shrink-0 relative group">
                          <img
                            :src="
                              subtask.talent.profile_picture ||
                              require('@/assets/users/default-profile-picture.jpg')
                            "
                            alt="Profile Picture"
                            class="w-full h-full rounded-full object-cover"
                          />
                          <span
                            class="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 px-2 py-1 text-xs text-white bg-black rounded opacity-0 group-hover:opacity-100"
                          >
                            {{ subtask.talent.first_name }}
                            {{ subtask.talent.last_name }}
                          </span>
                        </div>
                      </div>
                      <div v-else-if="subtask.team">
                        <div class="flex -space-x-2">
                          <template
                            v-for="(member) in subtask.team.members.slice(0, 3)"
                            :key="member.id"
                          >
                            <div class="w-6 h-6 flex-shrink-0 relative group">
                              <img
                                :src="
                                  member.profile_picture ||
                                  require('@/assets/users/default-profile-picture.jpg')
                                "
                                alt="Profile Picture"
                                class="w-full h-full rounded-full object-cover"
                              />
                              <span
                                class="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 px-2 py-1 text-xs text-white bg-black rounded opacity-0 group-hover:opacity-100"
                              >
                                {{ member.first_name }} {{ member.last_name }}
                              </span>
                            </div>
                          </template>
                          <div
                            v-if="subtask.team.members.length > 3"
                            class="w-6 h-6 flex-shrink-0 flex items-center justify-center bg-gray-300 text-xs text-white rounded-full"
                          >
                            +{{ subtask.team.members.length - 3 }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <div class="flex items-center gap-2">
                      <div v-if="subtask.created_by">
                        <div class="w-6 h-6 flex-shrink-0 relative group">
                          <img
                            :src="
                              subtask.created_by.profile_picture ||
                              require('@/assets/users/default-profile-picture.jpg')
                            "
                            alt="Created By Picture"
                            class="w-full h-full rounded-full object-cover"
                          />
                          <span
                            class="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 px-2 py-1 text-xs text-white bg-black rounded opacity-0 group-hover:opacity-100"
                          >
                            {{ subtask.created_by.first_name }}
                            {{ subtask.created_by.last_name }}
                          </span>
                        </div>
                      </div>
                      <div v-else>
                        <div class="w-6 h-6 flex-shrink-0 relative group">
                          <img
                            :src="require('@/assets/users/default-profile-picture.jpg')"
                            alt="No Creator"
                            class="w-full h-full rounded-full object-cover"
                          />
                          <span
                            class="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 px-2 py-1 text-xs text-white bg-black rounded opacity-0 group-hover:opacity-100"
                          >
                            N/A
                          </span>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    {{ formatDate(subtask.start_date) }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    {{ formatDate(subtask.due_date) }}
                  </td>
                  <td
                    class="flex items-center gap-2 px-6 py-4 whitespace-nowrap"
                  >
                    <img
                      :src="getPriorityFlag(subtask.priority)"
                      alt="Priority Flag"
                      class="h-3"
                    />
                    {{ subtask.priority }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-center">
                    <button
                      @click="toggleMenu(subtask.task_id, $event)"
                      class="cursor-pointer relative"
                    >
                      <img
                        src="@/assets/tasks/ellipse.svg"
                        alt="Actions"
                        class="w-4 h-4"
                      />
                    </button>
                    <div
                      v-if="menuVisibility[subtask.task_id]?.visible"
                      :style="{
                        position: 'fixed',
                        top: `${menuVisibility[subtask.task_id]?.top}px`,
                        left: `${menuVisibility[subtask.task_id]?.left}px`,
                        zIndex: 50
                      }"
                      class="w-40 bg-white shadow-lg rounded-lg"
                    >
                      <!-- Invisible overlay -->
                      <div
                        class="fixed inset-0 bg-transparent"
                        @click="closeAllMenus"
                      ></div>
                      <!-- Menu content -->
                      <ul class="text-sm text-gray-700 relative z-10">
                        <li
                          @click="handleAction('view', subtask)"
                          class="px-4 py-2 hover:bg-gray-100 flex items-center gap-2 cursor-pointer"
                        >
                          <img
                            src="@/assets/auth/view.svg"
                            alt="View"
                            class="w-4 h-4"
                          />
                          View
                        </li>
                        <li
                          @click="handleAction('rename', subtask)"
                          class="px-4 py-2 hover:bg-gray-100 flex items-center gap-2 cursor-pointer"
                        >
                          <img
                            src="@/assets/tasks/rename.svg"
                            alt="Rename"
                            class="w-4 h-4"
                          />
                          Rename
                        </li>
                        <li
                          @click="handleAction('edit', subtask)"
                          class="px-4 py-2 hover:bg-gray-100 flex items-center gap-2 cursor-pointer"
                        >
                          <img
                            src="@/assets/tasks/rename.svg"
                            alt="Rename"
                            class="w-4 h-4"
                          />
                          Edit
                        </li>
                        <li
                          @click="handleAction('sub-duplicate', subtask)"
                          class="px-4 py-2 hover:bg-gray-100 flex items-center gap-2 cursor-pointer"
                        >
                          <img
                            src="@/assets/tasks/copy.svg"
                            alt="Duplicate"
                            class="w-4 h-4"
                          />
                          Duplicate
                        </li>
                        <li
                          @click="handleAction('delete', subtask)"
                          class="px-4 py-2 hover:bg-gray-100 flex items-center gap-2 cursor-pointer"
                        >
                          <img
                            src="@/assets/tasks/trash.svg"
                            alt="Delete"
                            class="w-4 h-4"
                          />
                          Delete
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TaskStatusSection",
  props: {
    tasks: {
      type: Array,
      required: true,
    },
    status: {
      type: String,
      required: true,
    },
    isDropdownVisible: {
      type: Boolean,
      required: true,
    },
    subtasks: {
      type: Object,
      default: () => ({}),
    },
    subtaskVisibility: {
      type: Object,
      default: () => ({}),
    },
    talentEmails: {
      type: Object,
      default: () => ({}),
    },
    isAdmin: Boolean,
    isManager: Boolean,
    taskLimit: {
      type: Object,
      default: null,
    },
  },
  emits: [
    "toggle-dropdown",
    "toggle-subtasks",
    "open-side-menu",
    "open-task-modal",
    "delete-task",
    "open-create-sub-task-modal",
    "open-duplicate-task-modal",
    "open-edit-task-modal",
    "open-duplicate-sub-task-modal",
    "open-rename-task-modal",
  ],
  data() {
    return {
      menuVisibility: {},
      sortField: null,
      sortOrder: null,
    };
  },
  computed: {
    statusConfig() {
      const configs = {
        "In Progress": {
          label: "In Progress",
          dotColor: "bg-[#53D65A]",
          emptyMessage: "No tasks in progress yet.",
        },
        "Not Started": {
          label: "Not Started",
          dotColor: "bg-[#E0921E]",
          emptyMessage: "No tasks to start yet.",
        },
        Done: {
          label: "Done",
          dotColor: "bg-[#3B82F6]",
          emptyMessage: "No done tasks yet.",
        },
        Completed: {
          label: "Completed",
          dotColor: "bg-[#22C55E]",
          emptyMessage: "No completed tasks yet.",
        },
      };
      return configs[this.status] || configs["In Progress"];
    },
    sortedTasks() {
      if (!this.sortField || !this.sortOrder) {
        return this.tasks;
      }

      return [...this.tasks].sort((a, b) => {
        let aValue, bValue;

        switch (this.sortField) {
          case 'name':
            aValue = a.title.toLowerCase();
            bValue = b.title.toLowerCase();
            break;
          case 'assignee':
            if (a.talent) {
              aValue = `${a.talent.first_name} ${a.talent.last_name}`.toLowerCase();
            } else if (a.team) {
              aValue = a.team.name ? a.team.name.toLowerCase() : '';
            } else {
              aValue = '';
            }
            
            if (b.talent) {
              bValue = `${b.talent.first_name} ${b.talent.last_name}`.toLowerCase();
            } else if (b.team) {
              bValue = b.team.name ? b.team.name.toLowerCase() : '';
            } else {
              bValue = '';
            }
            break;
          case 'start_date':
            aValue = new Date(a.start_date);
            bValue = new Date(b.start_date);
            break;
          case 'due_date':
            aValue = new Date(a.due_date);
            bValue = new Date(b.due_date);
            break;
          case 'priority': {
            const priorityOrder = { 'Low': 1, 'Medium': 2, 'High': 3 };
            aValue = priorityOrder[a.priority] || 0;
            bValue = priorityOrder[b.priority] || 0;
            break;
          }
          default:
            return 0;
        }

        if (aValue < bValue) {
          return this.sortOrder === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
          return this.sortOrder === 'asc' ? 1 : -1;
        }
        return 0;
      });
    },
  },
  methods: {
    toggleDropdown() {
      this.$emit("toggle-dropdown");
    },
    toggleSubtasks(taskId) {
      this.$emit("toggle-subtasks", taskId);
    },
    hasSubtasks(taskId) {
      return this.subtasks[taskId] && this.subtasks[taskId].length > 0;
    },
    formatDate(date) {
      // Your existing formatDate method
      return date;
    },
    toggleMenu(id, event) {
      const menuWidth = 160; // Width of the menu in pixels
      const menuHeight = 160; // Approximate height of the menu in pixels
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      
      // Get button position
      const buttonRect = event.currentTarget.getBoundingClientRect();
      // const buttonCenterX = buttonRect.left + buttonRect.width / 2;
      const buttonTop = buttonRect.top;
      
      // Default position (to the right of the button)
      let menuLeft = buttonRect.right;
      
      // Check if menu would go off screen to the right
      if (menuLeft + menuWidth > viewportWidth) {
        // Position menu to the left of the button instead
        menuLeft = buttonRect.left - menuWidth;
      }
      
      // Determine if menu should open upward
      const shouldOpenUpward = buttonTop + menuHeight > viewportHeight;
      let menuTop = shouldOpenUpward ? buttonTop - menuHeight : buttonTop;
      
      // Make sure menu doesn't go above the viewport
      if (menuTop < 0) {
        menuTop = 10;
      }

      this.menuVisibility = {
        ...this.menuVisibility,
        [id]: {
          visible: !this.menuVisibility[id]?.visible,
          top: menuTop,
          left: menuLeft,
          openUpward: shouldOpenUpward
        },
      };
    },
    closeAllMenus() {
      this.menuVisibility = {};
    },
    handleAction(action, item) {
      this.menuVisibility[item.task_id || item.subtask_id] = false;
      if (action === "delete") {
        this.$emit("delete-task", item);
      } else if (action === "view") {
        this.$emit("open-side-menu", item);
      } else if (action === "rename") {
        this.$emit("open-rename-task-modal", item);
      } else if (action === "duplicate") {
        this.$emit("open-duplicate-task-modal", item);
      } else if (action === "edit"){
        this.$emit("open-edit-task-modal", item);
      } else if (action === "add-sub-task") {
        this.$emit("open-create-sub-task-modal", item);
      } else if (action === "sub-duplicate") {
        this.$emit("open-duplicate-sub-task-modal", item);
      }
    },
    getPriorityFlag(priority) {
      const flags = {
        Low: require("@/assets/tasks/green-flag.svg"),
        Medium: require("@/assets/tasks/orange-flag.svg"),
        High: require("@/assets/tasks/red-flag.svg"),
      };
      return flags[priority] || require("@/assets/tasks/green-flag.svg");
    },
    sortBy(field) {
      if (this.sortField === field) {
        if (this.sortOrder === 'asc') {
          this.sortOrder = 'desc';
        } else if (this.sortOrder === 'desc') {
          this.sortField = null;
          this.sortOrder = null;
        }
      } else {
        this.sortField = field;
        this.sortOrder = 'asc';
      }
    },
  },
};
</script>



    <!-- <div v-if="selectedStatus === 'All' || selectedStatus === 'In Progress'">
      <div>
        <div
          class="bg-[#FAFBFC] py-3 px-6 flex justify-between items-center cursor-pointer"
          @click="toggleInProgressTaskDropdown"
        >
          <div class="flex items-center gap-5">
            <img
              :src="
                inProgressTasksDropdownVisible
                  ? require('@/assets/projects/Vector.svg')
                  : require('@/assets/projects/Vector-1.svg')
              "
              alt="Toggle"
              class="w-3 h-3"
            />
            <span class="flex items-center text-[14px] text-grayDark gap-2">
              <div class="w-2 h-2 bg-[#53D65A] rounded-full"></div>
              In Progress - {{ filteredInProgressTasks.length }}
            </span>
          </div>
          <div></div>
        </div>
        <div v-if="inProgressTasksDropdownVisible" class="overflow-x-auto">
          <div
            v-if="filteredInProgressTasks.length === 0"
            class="text-center py-16 text-gray-500"
          >
            <p
              class="mx-auto bg-primaryLight px-2 py-24 border border-grayLight rounded-[16px]"
            >
              No tasks in progress yet.
              <span @click="openTaskModal" class="text-blue-500 cursor-pointer"
                >Create a new task</span
              >.
            </p>
          </div>
          <div v-else>
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-[#FAFBFC]">
                <tr class="text-[12px] font-medium text-bodyText">
                  <th scope="col" class="pl-16 pr-6 py-3 text-left tracking-wider">
                    Name
                  </th>
                  <th scope="col" class="px-6 py-3 text-left tracking-wider">
                    Assignee
                  </th>
                  <th scope="col" class="px-6 py-3 text-left tracking-wider">
                    Due Date
                  </th>
                  <th scope="col" class="px-6 py-3 text-left tracking-wider">
                    Priority
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <template
                  v-for="task in filteredInProgressTasks"
                  :key="task.task_id"
                >
                  <tr
                    class="mb-2 bg-[#FAFBFC] cursor-pointer text-[13px] text-grayDark hover:bg-primaryLight"
                  >

                    <td
                      class="pl-20 pr-6 py-4 whitespace-nowrap text-bodyText truncate max-w-[400px] flex gap-2 items-center"
                    >
                      <img
                        v-if="hasSubtasks(task.task_id)"
                        :src="
                          subtaskVisibility[task.task_id]
                            ? require('@/assets/projects/Vector.svg')
                            : require('@/assets/projects/Vector-1.svg')
                        "
                        alt="Toggle Subtasks"
                        class="w-3 h-3 cursor-pointer"
                        @click="toggleSubtasks(task.task_id)"
                      />
                      <p @click="openSideMenu(task)" class="cursor-pointer">
                        {{ task.title }}
                      </p>
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap">
                      {{ talentEmails[task.assigned_to] }}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap">
                      {{ formatDate(task.due_date) }}
                    </td>
                    <td
                      class="flex items-center gap-2 px-6 py-4 whitespace-nowrap"
                    >
                      <img
                        src="@/assets/tasks/flag.svg"
                        alt="Options"
                        class="h-4 cursor-pointer"
                      />
                      {{ task.priority }}
                    </td>
                  </tr>

                  <template
                    v-if="
                      subtaskVisibility[task.task_id] &&
                      hasSubtasks(task.task_id)
                    "
                  >
                    <tr
                      v-for="subtask in subtasks[task.task_id]"
                      :key="subtask.subtask_id"
                      class="bg-gray-50 cursor-pointer text-[12px] text-grayDark hover:bg-gray-100 border-gray-300"
                    >
                      <td
                        class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                      ></td>
                      <td
                        class="px-16 py-4 whitespace-nowrap text-bodyText truncate max-w-[400px]"
                      >
                        <div class="flex items-center gap-2">
                          <input
                            type="radio"
                            :name="`subtask-${task.task_id}`"
                            :value="subtask.subtask_id"
                            class="w-3 h-3 text-blue-600 cursor-pointer"
                          />
                          <p @click="openSideMenu(task)" class="cursor-pointer">
                            {{ subtask.title }}
                          </p>
                        </div>
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap">
                        {{ talentEmails[subtask.assigned_to] || "Unassigned" }}
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap">
                        {{ formatDate(subtask.due_date) }}
                      </td>
                      <td
                        class="flex items-center gap-2 px-6 py-4 whitespace-nowrap"
                      >
                        <img
                          src="@/assets/tasks/flag.svg"
                          alt="Options"
                          class="h-4 cursor-pointer"
                        />
                        {{ subtask.priority }}
                      </td>
                    </tr>
                  </template>
                </template>
                <div v-if="isAdmin || isManager" class="px-4 py-3 mt-4">
                  <button
                    @click="addNewSubtask"
                    class="flex items-center gap-2 text-[13px] text-grayDark hover:text-blue-800 cursor-pointer"
                  >
                    <div class="p-1 bg-[#EFF4FF] rounded-[4px]">
                      <img
                        src="@/assets/tasks/add.svg"
                        alt="add icon"
                        class="h-4 w-4"
                      />
                    </div>
                    <span>Add subtask</span>
                  </button>
                </div>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div v-if="selectedStatus === 'All' || selectedStatus === 'Completed'">
      <div>
        <div
          class="bg-[#FAFBFC] py-3 px-6 flex justify-between items-center cursor-pointer"
          @click="toggleCompletedTaskDropdown"
        >
          <div class="flex items-center gap-5">
            <img
              :src="
                completedTasksDropdownVisible
                  ? require('@/assets/projects/Vector.svg')
                  : require('@/assets/projects/Vector-1.svg')
              "
              alt="Toggle"
              class="w-3 h-3"
            />
            <span class="flex items-center text-[14px] gap-2">
              <div class="w-2 h-2 bg-[#53D65A] rounded-full"></div>
              Completed - {{ filteredCompletedTasks.length }}
            </span>
          </div>
          <div></div>
        </div>

        <div v-if="completedTasksDropdownVisible" class="overflow-x-auto">
          <div
            v-if="filteredCompletedTasks.length === 0"
            class="text-center py-16 text-gray-500"
          >
            <p
              class="mx-auto bg-primaryLight px-2 py-24 border border-grayLight rounded-[16px]"
            >
              No Completed tasks yet.
              <span @click="openTaskModal" class="text-blue-500 cursor-pointer"
                >Create a new task</span
              >.
            </p>
          </div>
          <div v-else>
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-[#FAFBFC]">
                <tr class="text-[12px] font-medium text-bodyText">
                  <th
                    scope="col"
                    class="px-6 py-3 text-left tracking-wider"
                  ></th>
                  <th scope="col" class="px-6 py-3 text-left tracking-wider">
                    Name
                  </th>
                  <th scope="col" class="px-6 py-3 text-left tracking-wider">
                    Assignee
                  </th>
                  <th scope="col" class="px-6 py-3 text-left tracking-wider">
                    Due Date
                  </th>
                  <th scope="col" class="px-6 py-3 text-left tracking-wider">
                    Priority
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr
                  v-for="task in filteredCompletedTasks"
                  :key="task.task_id"
                  @click="openSideMenu(task)"
                  class="mb-2 bg-[#FAFBFC] cursor-pointer hover:bg-primaryLight"
                >
                  <td
                    class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                  ></td>
                  <td
                    class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 truncate max-w-[400px]"
                  >
                    {{ task.title }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {{ talentEmails[task.assigned_to] }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {{ formatDate(task.due_date) }}
                  </td>
                  <td
                    class="flex items-center gap-2 px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                  >
                    <img
                      src="@/assets/tasks/flag.svg"
                      alt="Options"
                      class="h-4 cursor-pointer"
                    />
                    {{ task.priority }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div v-if="selectedStatus === 'All' || selectedStatus === 'Not Started'">
      <div>
        <div
          class="bg-[#FAFBFC] py-3 px-6 flex justify-between items-center cursor-pointer"
          @click="notStartedTaskDropdown"
        >
          <div class="flex items-center gap-5">
            <img
              :src="
                notStartedTasksDropdownVisible
                  ? require('@/assets/projects/Vector.svg')
                  : require('@/assets/projects/Vector-1.svg')
              "
              alt="Toggle"
              class="w-3 h-3"
            />
            <span class="flex items-center text-[14px] gap-2">
              <div class="w-2 h-2 bg-[#E0921E] rounded-full"></div>
              Not Started - {{ filteredNotStartedTasks.length }}
            </span>
          </div>
          <div></div>
        </div>

        <div v-if="notStartedTasksDropdownVisible" class="overflow-x-auto">
          <div
            v-if="filteredNotStartedTasks.length === 0"
            class="text-center py-16 text-gray-500"
          >
            <p
              class="mx-auto bg-primaryLight px-2 py-24 border border-grayLight rounded-[16px]"
            >
              No new tasks to start.
              <span @click="openTaskModal" class="text-blue-500 cursor-pointer"
                >Create a new task</span
              >.
            </p>
          </div>
          <div v-else>
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-[#FAFBFC]">
                <tr class="text-[12px] font-medium text-bodyText">
                  <th
                    scope="col"
                    class="px-6 py-3 text-left tracking-wider"
                  ></th>
                  <th scope="col" class="px-6 py-3 text-left tracking-wider">
                    Name
                  </th>
                  <th scope="col" class="px-6 py-3 text-left tracking-wider">
                    Assignee
                  </th>
                  <th scope="col" class="px-6 py-3 text-left tracking-wider">
                    Due Date
                  </th>
                  <th scope="col" class="px-6 py-3 text-left tracking-wider">
                    Priority
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr
                  v-for="task in filteredNotStartedTasks"
                  :key="task.task_id"
                  @click="openSideMenu(task)"
                  class="mb-2 bg-[#FAFBFC] cursor-pointer hover:bg-primaryLight"
                >
                  <td
                    class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                  ></td>

                  <td
                    class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 truncate max-w-[400px]"
                  >
                    {{ task.title }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {{ talentEmails[task.assigned_to] }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {{ formatDate(task.due_date) }}
                  </td>

                  <td
                    class="flex items-center gap-2 px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                  >
                    <img
                      src="@/assets/tasks/flag.svg"
                      alt="Options"
                      class="h-4 cursor-pointer"
                    />
                    {{ task.priority }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div> -->